/**
 * CIENA — Cart FAB shift
 * ---------------------------------------------------------------------------------------------------
 * O FAB do WhatsApp (app Kevi, .kevi-whatsapp-float-button) fica fixo no canto inferior direito e
 * sobrepõe o preço/subtotal/checkout quando o cart drawer abre.
 *
 * O FAB é injetado pelo app dentro de um wrapper que vem ANTES de <cart-drawer> no DOM, então CSS
 * com combinador irmão não o alcança. Este controller adiciona/remove a classe .ciena-fab-shifted
 * direto no FAB quando o cart drawer abre/fecha — o transform real está no CSS (component-cart-drawer.css),
 * desktop = desliza p/ esquerda, mobile = sobe acima do rodapé. NÃO esconde o botão.
 *
 * Robusto a: FAB carregado async (re-busca a cada abertura) e aninhamento (querySelector global).
 * Escopo: SÓ o cart drawer (não menu/busca), via observação de cart-drawer.active.
 * ---------------------------------------------------------------------------------------------------
 */
(function () {
  if (window.__cienaFabShift) return;
  window.__cienaFabShift = true;

  var CLS = 'ciena-fab-shifted';

  function fabs() {
    return document.querySelectorAll('.kevi-whatsapp-float-button, .kevi-whatsapp-popup-overlay');
  }

  function apply(active) {
    fabs().forEach(function (el) {
      el.classList.toggle(CLS, active);
    });
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var sync = function () { apply(drawer.classList.contains('active')); };

    // reage à abertura/fechamento do drawer
    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // o FAB do app carrega depois — se o drawer já estiver aberto quando ele aparecer, sincroniza
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { sync(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
